export const TRIAL_STORE_USER_GROUP = "store.trial";
